import { fetchNothing } from './fetch-nothing';

export const storeFeedback = async ({
    cloudId,
    feedback,
    messageId,
    feedbackLabel,
    detailedFeedback,
}: {
    readonly cloudId: string;
    readonly feedback: 'like' | 'dislike';
    readonly messageId?: string;
    readonly feedbackLabel?: string;
    readonly detailedFeedback?: string;
}) => {
    if (!messageId) {
        return;
    }
    await fetchNothing(
        `/gateway/api/jsm/help/spike/cloudid/${cloudId}/v1/conversation-metadata/${messageId}`,
        'PATCH',
        {
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ feedback, feedbackMessage: feedbackLabel, additionalFeedback: detailedFeedback }),
        }
    ).catch((error) => {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, no-console
        console.error(`Failed to store feedback for messageId: ${messageId}. Error: ${error}`);
    });
};

export const storeFeedbackAIMate = async ({
    channelId,
    messageId,
    feedback,
    feedbackLabel,
}: {
    readonly channelId: string;
    readonly messageId?: string;
    readonly feedback: 'LIKE' | 'DISLIKE';
    readonly feedbackLabel?: string;
}) => {
    if (!messageId) {
        return;
    }
    await fetchNothing(`/gateway/api/assist/chat/v1/channel/${channelId}/message/${messageId}/feedback`, 'PUT', {
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ feedback_value: feedback, feedback_message: feedbackLabel }),
    });
};
